import axios from "axios";

const systemBar = {
    state: {
        notIssuedCount: 0
    },

    actions: {
        async A_NOT_ISSUED_COUNT ({commit}) {
            const count = await axios.get('/api/order/not-formalized')
            await commit('M_NOT_ISSUED_COUNT', count.data.notFormalized)
        }
    },

    mutations: {
        M_NOT_ISSUED_COUNT (state, data) {
            state.notIssuedCount = data
        }
    },
    getters: {
        GET_NOT_ISSUED_COUNT: (state) => {
            return state.notIssuedCount
        }
    }
}

export default systemBar
